"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_SRC = "/image/new-version/casting/Metal-Casting/what-is-metal-casting.webp";

const GlobeIcon = ({ className }: { className?: string }) => (
	<svg
		className={`h-14 w-14 sm:h-16 sm:w-16 md:h-[72px] md:w-[72px] lg:h-20 lg:w-20 ${className ?? ""}`}
		viewBox="0 0 48 48"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<circle cx="24" cy="24" r="20" />
		<ellipse cx="24" cy="24" rx="20" ry="8" />
		<ellipse cx="24" cy="24" rx="8" ry="20" />
	</svg>
);

const DESC_KEYS = ["whatIsDesc1", "whatIsDesc2", "whatIsDesc3"] as const;

export default function WhatIsMetalCasting() {
	const t = useTranslations("new-metal-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="relative mb-8 flex min-h-[72px] items-center sm:mb-10 sm:min-h-[80px] md:mb-12 md:min-h-[88px]">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						<span className="block">{t("whatIsTitleLine1")}</span>
						<span className="block">{t("whatIsTitleLine2")}</span>
					</h2>
					<div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
						<GlobeIcon className="text-themePrimary400" />
					</div>
				</div>

				<div className="flex flex-col gap-8 lg:flex-row lg:items-stretch lg:gap-8 xl:gap-10">
					<div className="flex w-full flex-col lg:min-w-0 lg:flex-1">
						<div className="relative aspect-[4/3] w-full overflow-hidden shadow-lg lg:aspect-auto lg:h-full lg:min-h-[410px]">
							<Image
								src={IMAGE_SRC}
								alt={t("whatIsImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>

					<div className="flex w-full min-w-0 flex-1 flex-col justify-center lg:min-w-0">
						<div className="mb-8 space-y-5">
							{DESC_KEYS.map((key) => (
								<p key={key} className="text-sm leading-relaxed text-black md:text-base">
									{t(key)}
								</p>
							))}
						</div>

						<Link
							href="/upload"
							className="inline-flex w-fit items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
						>
							{t("whatIsGetQuote")}
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
}
